module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-lazyload-15.ba79c067.jpg";